<template>
  <div class="animated fadeIn">
    <Row>
      <Input v-model="keywordFilter" placeholder="错误信息/错误类型/报错Url" style="width: 200px; margin-right: 10px;"></Input>
      <Button type="primary" style="margin-right: 10px;" @click="onFilterClick">查询</Button>
    </Row>
    <Row style="margin-top: 10px;">
      <div>
        <div style="position:relative;">
          <Table height="600" :columns="columns" :stripe="true" :data="content" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page :total="totalElements" :page-size="pageSize" :show-total="true" show-elevator @on-change="setPage"
              style="text-align:right;margin-top:10px;"></Page>

      </div>
    </Row>
  </div>
</template>

<script>

  import Vue from 'vue'
  import store from '@/store'
  import {mapActions} from 'vuex'
  import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'

  export default {
    name: 'WebAdminErrorLog',
    data() {
      return {
        keywordFilter:null,
        tableHeight: 160,
        pageIndex: 1,
        sort: null,
        listLoadding: false,

        columns: [
          {
            title: 'ID',
            key: 'id',
            sortable: 'custom',
            tooltip: 'true',
            minWidth: 100
          },
          {
            title: '错误码',
            key: 'code',
            ellipsis: 'true',
            minWidth: 80
          },
          {
            title: '错误类型',
            key: 'type',
            ellipsis: 'true',
            minWidth: 90
          },
          {
            title: '错误信息',
            key: 'mes',
            ellipsis: 'true',
            minWidth: 300
          },
          {
            title: '报错Url',
            key: 'url',
            ellipsis: 'true',
            minWidth: 400
          },
          {
            title: '记录时间',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            key: 'createDate',
            minWidth: 180,
            render: function (h, params) {
              if (params.row.createDatetime) {
                let d = new Date(params.row.createDatetime)
                return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
              }
            }
          }
        ]//cloumn
      }//return
    },//data
    methods: {
      ...mapActions([
        'WebAdminErrorLogServ_GetPage'
      ]),
      onFilterClick(){
        this.setPage(1)
      },
      sortChange({column, key, order}) {
        this.sort = {
          name: key,
          asc: order === 'asc' ? true : false
        }
        this.refreshPage()
      },
      setPage(page) {
        this.pageIndex = page
        this.listLoadding = true

        let sortParam = null

        if (this.sort !== null && this.sort !== undefined) {
          sortParam = genSortParam(this.sort.name, this.sort.asc)
        } else {
          sortParam = genSortParam('id', false)
        }

        store.dispatch('WebAdminErrorLogServ_GetPage', {
          params: null,
          urlparams: {
            p: page,
            keyword: this.keywordFilter,
            sort: sortParam
          }
        }).then(() => {
          this.listLoadding = false
        }).catch(err => {
          this.listLoadding = false
          this.$Message.error(err)
        });
      },
      //刷新当前页
      refreshPage() {
        this.setPage(this.pageIndex)
      }
    },
    computed: {
      totalElements() {
        if (store.getters.get_WebAdminErrorLog_GetPageResult) {
          return store.getters.get_WebAdminErrorLog_GetPageResult.totalElements
        } else {
          return 0
        }
      },
      content() {
        if (store.getters.get_WebAdminErrorLog_GetPageResult) {
          return store.getters.get_WebAdminErrorLog_GetPageResult.content
        } else {
          return []
        }
      },
      pageSize() {
        if (store.getters.get_WebAdminErrorLog_GetPageResult) {
          return store.getters.get_WebAdminErrorLog_GetPageResult.size
        } else {
          return 0
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 230;
        this.setPage(1)
      });
    },
  }
</script>

<style scoped>
</style>
